import { useState } from 'react';

import { useCurrentUser, useHomeCardActions } from '@/hooks';
import { ActionCard } from '@/ui';
import { oldCoachToNew } from '@/utils';

import HomeCardContent from './HomeCardContent';
import HomeCardMedia from './HomeCardMedia';

import type { Coach, HomeCardProps } from '@/types';
import type { FC } from 'react';

import ScheduleSession from '@/components/Cal/scheduleSession';

const HomeCard: FC<HomeCardProps> = ({ onDismiss, refetch, ...card }) => {
  const { actions, isScheduleOpen, onCloseSchedule } = useHomeCardActions({
    card,
  });
  const { user } = useCurrentUser();
  const [clickedMap, setClickedMap] = useState<Record<string, boolean>>({});

  const handleDismiss = () => {
    onDismiss(card.id);
  };
  let coach;
  if (card.coach) {
    coach = oldCoachToNew(card.coach as Coach, user.coaches);
  }

  // Guard against double clicks: disable a button once clicked
  const guardedActions = (actions || []).map((action) => {
    const key = action.label;
    const alreadyClicked = !!clickedMap[key];
    return {
      ...action,
      buttonProps: {
        ...action.buttonProps,
        disabled: alreadyClicked || action.buttonProps?.disabled,
        loading: alreadyClicked || action.buttonProps?.loading,
      },
      onClick: (event: unknown) => {
        if (alreadyClicked) {
          return;
        }
        setClickedMap((prev) => ({ ...prev, [key]: true }));
        action.onClick?.(event as never);
      },
    };
  });

  return (
    <>
      <ActionCard
        key={card.id}
        {...card}
        actions={guardedActions}
        cardMedia={<HomeCardMedia card={card} />}
        onClose={card.isDismissable ? handleDismiss : undefined}
      >
        <HomeCardContent card={card} />
      </ActionCard>
      {isScheduleOpen && coach && (
        <ScheduleSession
          key={coach.id}
          callback={refetch}
          client={user}
          close={onCloseSchedule}
          coach={coach}
        />
      )}
    </>
  );
};

export default HomeCard;
